export const comingSoonDataMock = [
  {
    reason: 'Inconclusivo',
    count: 0,
    offline_percentage: '0.0%',
  },
  {
    count: 0,
    reason: 'Total',
    strong: true,
    offline_percentage: '0.0%',
  },
];
